import { makeStyles } from '@material-ui/core/styles';
import { ArrowDropDown } from '@material-ui/icons';
import clsx from 'clsx';
import { useState } from 'react';
import { CheckboxMenu, CheckboxMenuOption } from './checkboxMenu';
import { DASHBOARD_COLORS } from './statusDashboardStyles';

const useStyles = makeStyles(() => ({
  root: {
    width: 'calc(100% - 16px)',
    minWidth: 0,
    height: 28,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    padding: '0 2px 0 8px',
    fontSize: 13,
    border: `1px solid ${DASHBOARD_COLORS.border}`,
    borderRadius: 4,
    background: '#fff',
    cursor: 'pointer',
    userSelect: 'none',
  },
  open: {
    borderColor: DASHBOARD_COLORS.muted,
  },
  value: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  arrow: {
    color: DASHBOARD_COLORS.muted,
  },
}));

interface ColumnSelectFilterProps {
  // Values ticked, comma separated as the filters are sent; empty for every value
  value: string;
  options: CheckboxMenuOption[];
  onFilter: (value: string) => void;
  // For long lists such as the senders: the options can be searched
  searchable?: boolean;
}

// Multi select under a column title for columns with known values, like the select filters of the leads dashboard
export const ColumnSelectFilter = ({
  value,
  options,
  onFilter,
  searchable,
}: ColumnSelectFilterProps) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const selected = value ? value.split(',') : [];
  const labelOf = (selectedValue: string) =>
    options.find(option => option.value === selectedValue)?.label ??
    selectedValue;

  const toggle = (option: string) =>
    onFilter(
      (selected.includes(option)
        ? selected.filter(v => v !== option)
        : [...selected, option]
      ).join(',')
    );

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        className={clsx(classes.root, anchorEl && classes.open)}
        onClick={e => setAnchorEl(e.currentTarget)}
        onKeyDown={e =>
          (e.key === 'Enter' || e.key === ' ') && setAnchorEl(e.currentTarget)
        }
      >
        <span className={classes.value}>
          {selected.map(labelOf).join(', ')}
        </span>
        <ArrowDropDown className={classes.arrow} />
      </div>
      <CheckboxMenu
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        options={options}
        selected={selected}
        onToggle={toggle}
        searchable={searchable}
      />
    </>
  );
};
